{
  "title": "アカウントとプロフィール",
  "languageSection": "言語と地域",
  "preferredLanguage": "使用する言語",
  "preferredLanguageHelp": "サイト全体および当社からのメールに適用されます。",
  "profile": "公開プロフィール",
  "notifications": "お知らせ",
  "emailPreferences": "メール設定"
}
